import fetch from '../utils/fetch'

export function searchAPI(data) {
    return fetch({
        url:  '/member/search',
        method: "get",
        params: data,
    })
}